import { Log } from 'probe.gl';
export default new Log({
  id: 'deck'
}).enable();
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/core/dist/esm/utils/log.js
// module id = 47
// module chunks = 0